import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import pickerOption from '@/mixins/module/pickerOption';
export default {
  components: {},
  mixins: [pickerOption],
  data: function data() {
    return {
      date: '',
      dailyData: {}
    };
  },
  computed: {},
  created: function created() {
    this.date = this.$times.theDay();
    this.getData();
  },
  mounted: function mounted() {},
  methods: {
    getData: function getData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$api.getDailyData({
                  date: _this.date
                }).then(function (res) {
                  if (res.code == 200) {
                    _this.dailyData = res.data;
                  }
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};